import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { DialogService } from 'primeng/dynamicdialog';
import { ToastModule } from 'primeng/toast';
import { AdelaideService } from './core/adelaide/adelaide.service';
import { GoogleMapsService } from './core/google-maps/google-maps.service';
import { ContentComponent } from './core/iam-with-primeng/components/content.component';
import { FaviconService } from './core/services/favicon.service';
import { CoreStore } from './core/store/core.store';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { LoadingService } from './shared/services/loading.service';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, ConfirmDialog, LoadingComponent, ContentComponent],
  providers: [DialogService, LoadingService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<app-loading /><p-toast />
    <p-toast position="bottom-center" key="bc">
      <ng-template #headless let-message>
        <div class="text-center p-2">
          <span>{{ message.detail }}</span>
        </div>
      </ng-template> </p-toast
    ><p-confirmdialog /><router-outlet /><app-iam-with-ngzorro-content /> `,
})
export class AppComponent {
  private readonly googleMapsService: GoogleMapsService = inject(GoogleMapsService);
  private readonly titleService = inject(Title);
  private readonly faviconService = inject(FaviconService);
  private readonly coreStore = inject(CoreStore);
  private readonly adelaideService = inject(AdelaideService);
  readonly tenant = this.coreStore.tenant;

  constructor() {
    this.titleService.setTitle(`SOE | ${this.tenant().name}`);
    this.faviconService.set(this.tenant().favicon);
    this.googleMapsService.load();
    this.adelaideService.load();
  }
}
